import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {StandingsSeasonsFilterApiModel} from "./standings.seasons-filter.api-model";

export class StandingsSeasonsFilterDomainModel extends BaseDomainModel {
  apiModel: StandingsSeasonsFilterApiModel;

  get seasonNum(): Number {
    return this.apiModel.seasonNum;
  }

  get seasonName(): String {
    return this.apiModel.seasonName;
  }
}
